import React from 'react'
import { HideWordMode, ShowWordMode } from '../types'

interface WordControlsProps {
	hiddenPercentage: number;
	onHiddenPercentageChange: (percentage: number) => void;
	onShuffle: () => void;
	showWordMode: ShowWordMode;
	onShowWordModeChange: (mode: ShowWordMode) => void;
	hideWordMode: HideWordMode;
	onHideWordModeChange: (mode: HideWordMode) => void;
}

export const WordControls: React.FC<WordControlsProps> = ({
	hiddenPercentage,
	onHiddenPercentageChange,
	onShuffle,
	showWordMode,
	onShowWordModeChange,
	hideWordMode,
	onHideWordModeChange,
}) => {
	const stopper = (e: React.KeyboardEvent) => e.stopPropagation()

	return (
		<div className="word-controls">
			<div className="visibility-shuffle-row">
				<div className="visibility-control">
					<label htmlFor="visibility-slider">
						Words Hidden: {hiddenPercentage}%
					</label>
					<input
						id="visibility-slider"
						type="range"
						min="0"
						max="100"
						step="5"
						value={hiddenPercentage}
						onChange={(e) => onHiddenPercentageChange(e.target.valueAsNumber)}
						onKeyDown={stopper}
						className="visibility-slider"
					/>
				</div>

				<div className="shuffle-control">
					<button
						onClick={onShuffle}
						className="btn btn-secondary shuffle-btn"
						title="Shuffle word selection"
					>
						🔀 Shuffle
					</button>
				</div>
			</div>

			<div className="word-mode-row">
				<div className="word-mode-control">
					<label htmlFor="show-word-mode-select">Visible word display:</label>
					<select
						id="show-word-mode-select"
						value={showWordMode}
						onChange={(e) => onShowWordModeChange(e.target.value as ShowWordMode)}
						className="word-mode-select"
					>
						<option value="both">Word + Emoji</option>
						<option value="word">Word</option>
						<option value="symbol">Emoji/symbol or word</option>
						<option value="firstLetter">First letter</option>
						<option value="firstLetterEmoji">First letter + emoji</option>
					</select>
				</div>

				<div className="word-mode-control">
					<label htmlFor="word-mode-select">Hidden word display:</label>
					<select
						id="word-mode-select"
						value={hideWordMode}
						onChange={(e) => onHideWordModeChange(e.target.value as HideWordMode)}
						className="word-mode-select"
					>
						<option value="hide">Hide completely</option>
						<option value="firstLetter">First letter</option>
						<option value="symbol">Emoji/symbol only</option>
						<option value="firstLetterEmoji">First letter + emoji</option>
					</select>
				</div>
			</div>
		</div>
	)
}
